<template>
  <div style="padding: 0px 20px">
    <a-row :gutter="30">
      <a-col :span="15">
        <div style="margin-bottom: 20px">
          <j-dict-select-tag
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            allowClear
            style="width: 170px"
          />
          <!--  -->

          <j-dict-select-tag
            placeholder="请选择班级"
            v-model="queryParam.classId"
            :dictCode="
              'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
            "
            :async="true"
            style="width: 170px; margin-left: 10px"
          />
             <!-- :dictCode="
              'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
            " -->
          <a-button type="primary" style="margin-left: 10px" @click="tableQuery">查询</a-button>
          <a-button type="primary" style="margin-left: 10px" icon="download" @click="exportXls">
            导出
          </a-button>
        </div>
        <TableList
          :columns="schoolTableConfig.columns"
          :tableData="schoolTableConfig.tableData"
          :scroll="false"
          :loading="schoolTableConfig.loading"
          :pagination="schoolTableConfig.pagination"
          @change="handleTableChange"
        >
          <template slot="action" slot-scope="slotProps">
            <span class="action-detail" @click="viewDetails(slotProps)">查看详情</span>
          </template>
        </TableList>
      </a-col>
      <a-col :span="9">
        <div style="font-size: 16px; font-weight: bold">班级详情</div>
        <a-tabs :default-active-key="tabKey" @change="handleTabChange">
          <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
            <TableList
              :columns="item.columns"
              :tableData="item.tableData"
              :loading="item.loading"
              :pagination="item.pagination"
              @change="changeLeftTable"
            >
              <!-- 内容插槽部分 -->
              <template slot="emotionalState" slot-scope="{ record }">
                <img
                  style="width: 20px; height: 20px"
                  :src="
                    require(`@assets/schoolChangeTrend/${renderPhizIcon(
                      record.emotionalState
                    )}.png`)
                  "
                />
              </template>
              <template slot="warnFlag" slot-scope="{ record }">
                <img
                  v-if="record.warnFlag == 1"
                  style="width: 20px; height: 20px"
                  :src="require(`@assets/schoolChangeTrend/forewarning.png`)"
                />
              </template>
              <template slot="action" slot-scope="{ record }">
                <span class="action-detail" @click="viewModal(record, 2)">查看</span>
              </template>
            </TableList>
          </a-tab-pane>
        </a-tabs>
      </a-col>
    </a-row>
    <!--    <ViewKeyPointModal ref="viewKeyPointModal" />-->
  </div>
</template>

<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
// import ViewKeyPointModal from '../ViewKeyPointModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import * as XLSX from 'xlsx'
import { openNewTabPage } from '@/utils/util'

const tabPagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'CampusMood',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    // ViewKeyPointModal,
  },
  data() {
    return {
      queryParam: {},
      gradeSelectItems: [],
      gradeOptions: [
        {
          label: '小学一年级',
          value: '1',
        },
        {
          label: '小学二年级',
          value: '2',
        },
      ],
      calssSelectItems: [],
      classOptions: [
        {
          label: '小学一年级一班',
          value: '1',
        },
        {
          label: '小学二年级二班',
          value: '2',
        },
      ],
      schoolTableConfig: {
        columns: [
          {
            title: '序号',
            dataIndex: 'index',
            align: 'center',
          },
          {
            title: '年级',
            dataIndex: 'student_grade',
            align: 'center',
          },
          {
            title: '班级',
            dataIndex: 'student_class',
            align: 'center',
          },
          {
            title: '正常人数',
            dataIndex: 'normal',
            align: 'center',
          },
          {
            title: '提醒人数',
            dataIndex: 'warn',
            align: 'center',
          },
          {
            title: '关爱人数',
            dataIndex: 'care',
            align: 'center',
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ],
        tableData: [],
        loading: false,
        pagination: { ...tabPagination },
      },
      tabPaneConfig: [
        {
          tab: '正常人数',
          key: 1,
          columns: [
            {
              title: '姓名',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '昨日心情',
              dataIndex: 'emotionalState',
              align: 'center',
              scopedSlots: { customRender: 'emotionalState' },
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tabPagination },
        },
        {
          tab: '提醒人数',
          key: 2,
          columns: [
            {
              title: '姓名',
              align: 'center',
              dataIndex: 'name',
            },
            {
              title: '昨日心情',
              align: 'center',
              dataIndex: 'emotionalState',
              scopedSlots: { customRender: 'emotionalState' },
            },
            {
              title: '关爱级别',
              align: 'center',
              dataIndex: 'careList',
            },
            {
              title: '状态',
              dataIndex: 'warnFlag',
              align: 'center',
              scopedSlots: { customRender: 'warnFlag' },
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tabPagination },
        },
        {
          tab: '关爱人数',
          key: 3,
          columns: [
            {
              title: '姓名',
              align: 'center',
              dataIndex: 'name',
            },
            {
              title: '昨日心情',
              align: 'center',
              dataIndex: 'emotionalState',
              scopedSlots: { customRender: 'emotionalState' },
            },
            {
              title: '关爱级别',
              align: 'center',
              dataIndex: 'careList',
            },
            {
              title: '状态',
              align: 'center',
              dataIndex: 'warnFlag',
              scopedSlots: { customRender: 'warnFlag' },
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tabPagination },
        },
      ],
      url: {
        list: '/statistic/clientSchoolMood',
        classDetailsUrl: '/statistic/classDetails',
        exportXlsUrl: '/statistic/clientSchoolMood',
      },
      tabKey: 1,
      currRowInfo: {},
    }
  },
  created() {
    this.getSchoolMood()
  },
  methods: {
    exportXls() {
      const exportData = []
      this.schoolTableConfig.tableData.forEach((data) => {
        var singleData = {}
        this.schoolTableConfig.columns.forEach((column) => {
          if (column.title !== '操作') {
            singleData[column.title] = data[column.dataIndex]
          }
        })
        exportData.push(singleData)
      })

      console.log('导出的数据格式：', exportData)

      // 将数据转化为xlsx的表格数据结构
      const ws = XLSX.utils.json_to_sheet(exportData)

      // 设置列宽
      ws['!cols'] = [
        { wpx: 40 }, // 第一列宽度为40像素
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
      ]

      // 开启自动换行并设置居中
      for (let cell in ws) {
        if (cell[0] === '!') continue // 跳过特殊属性
        if (!ws[cell].s) ws[cell].s = {} // 确保样式对象存在
        ws[cell].s.alignment = {
          wrapText: true, // 自动换行
          horizontal: 'center', // 水平居中
          vertical: 'center', // 垂直居中
        }
      }

      // 新建工作簿并添加表格数据
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '校园心情列表')

      // 生成Excel文件并导出
      XLSX.writeFile(wb, '校园心情列表.xlsx')
    },
    tableQuery() {
      console.log('查询--', this.queryParam)
      this.getSchoolMood()
    },
    handleTableChange(page) {
      this.$set(this.schoolTableConfig, 'pagination', page)
      this.getSchoolMood()
    },
    changeLeftTable(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.getClassMood()
    },
    getSchoolMood() {
      this.$set(this.schoolTableConfig, 'loading', true)
      const params = {
        ...this.queryParam,
        pageNo: this.schoolTableConfig.pagination.current,
        pageSize: this.schoolTableConfig.pagination.pageSize,
      }
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          const tableData = res.result.records.length
            ? res.result.records.map((item, index) => ({
                index: index + 1,
                ...item,
              }))
            : []
          this.$set(this.schoolTableConfig, 'tableData', tableData)
          this.$set(this.schoolTableConfig.pagination, 'total', res.result.total)
          this.$set(this.schoolTableConfig, 'loading', false)
          console.log('tableData--', this.schoolTableConfig.tableData)
          console.log('pagination--', this.schoolTableConfig.pagination.total)
        }
      })
    },
    // 查看详情
    viewDetails(row) {
      console.log('当前行数据--', row)
      this.currRowInfo = row.record
      this.getClassMood()
    },
    getClassMood() {
      if (!Object.keys(this.currRowInfo).length) return
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      getAction(this.url.classDetailsUrl, {
        classId: this.currRowInfo.class_id,
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        type: this.tabKey,
      })
        .then((res) => {
          if (res.success) {
            const tableData = res.result.records
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
          }
        })
        .catch((err) => {
          console.log('err--', err)
        })
    },
    handleTabChange(key) {
      this.tabKey = key
      this.getClassMood()
    },
    viewModal(record, type) {
      // console.log('查看--', record)
      // const studentInfo = { ...data.record, id: data.record.studentId }
      // this.$refs.viewKeyPointModal.show(studentInfo, type)
      openNewTabPage({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId || record.student_id,
          pagePath: '/school/statistic/SchoolChangeTrend',
          tab: 'mood',
        },
      })
    },
    handleSelectChange(selectItems, type) {
      console.log('选择的年级--', selectItems)
      switch (type) {
        case 'grade':
          this.gradeSelectItems = selectItems
          break
        case 'class':
          this.calssSelectItems = selectItems
          break
      }
    },
    // 渲染表情
    renderPhizIcon(status) {
      return status == 1
        ? 'happy-phiz'
        : status == -1
        ? 'unhappy-phiz'
        : status == 0
        ? 'normal-phiz'
        : 'warning-phiz'
    },
  },
}
</script>

<style scoped lang="less">
.action-detail {
  color: #0077fa !important;
  cursor: pointer !important;
}

::v-deep {
  .ant-tabs-nav-scroll {
    width: 100% !important;
    display: flex !important;
  }

  .ant-tabs-nav {
    display: flex !important;
    width: 100% !important;
  }

  .ant-tabs-ta {
    width: 33.33% !important;
  }
}
</style>
